import { render, staticRenderFns } from "./resources-detail.component.html?vue&type=template&id=8fd6402c&scoped=true&external"
import script from "./resources-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./resources-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./resources-detail.component.scss?vue&type=style&index=0&id=8fd6402c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd6402c",
  null
  
)

export default component.exports